import React, {Fragment, useContext, useEffect, useState} from 'react';
import {Col, Container, Modal, ModalBody, ModalFooter, ModalHeader, Row} from 'reactstrap';
import axiosConfig from "../../../../../Config/axios";
import {Btn} from "../../../../../AbstractElements";
import Loader from "../../../../../Layout/Loader";
import ExtraFieldForm from "./Form";
import {useForm} from "react-hook-form";
import TextInput from "../../../../../CommonElements/Input/TextInput";
import ButtonIcon from "../../../../../CommonElements/ButtonIcon";
import AuthorizationContext from "../../../../../_helper/Authorization";
import type {ExtraField, ExtraFieldShowProps} from "../../Types/ExtraFieldTypes";
import type {AuthorizationContextType} from "../../../../../_helper/Authorization/AuthorizationTypes";

const ExtraFieldShow: React.FC<ExtraFieldShowProps> = ({extraFieldModel}) => {
    const [loaderVisibility, setLoaderVisibility] = useState<boolean>(false);
    const [extraFields, setExtraFields] = useState<ExtraField[]>([]);
    const [selectedExtraField, setSelectedExtraField] = useState<ExtraField | undefined>();
    const [extraFieldModalVisibility, setExtraFieldModalVisibility] = useState<boolean>(false);
    const authContext = useContext(AuthorizationContext) as AuthorizationContextType;
    const {errorHandler} = authContext || {};

    const extraFieldModalToggle = () => {
        setExtraFieldModalVisibility(!extraFieldModalVisibility);
    }

    const {
        register,
    } = useForm();

    const getExtraFields = () => {
        setLoaderVisibility(true);
        const config = {params: {model: extraFieldModel}};
        axiosConfig
            .get(`/system-core/extra-field`, config)
            .then((response: { data: { data: ExtraField[]; }; }) => {
                if (response?.data?.data) {
                    setExtraFields(response.data.data);
                }
                setLoaderVisibility(false);
            })
            .catch((exception: any) => {
                errorHandler(exception);
                setLoaderVisibility(false);
            });
    }

    const handleExtraFieldEdit = (extraField: ExtraField) => {
        setSelectedExtraField(extraField);
        extraFieldModalToggle();
    }

    const deleteExtraField = (id: number) => {
        setLoaderVisibility(true);
        axiosConfig
            .delete(`/system-core/extra-field/${id}`, {})
            .then((response: { data: { data: { id: number; }; }; }) => {
                if (response?.data?.data) {
                    setExtraFields(current => current.filter(extraField => {
                        return extraField.id !== response?.data?.data?.id;
                    }));
                }
                setLoaderVisibility(false);
            })
            .catch((exception: any) => {
                errorHandler(exception);
                setLoaderVisibility(false);
            });
    }

    const updateExtraField = (extraField: ExtraField) => {
        const extraFieldList = [...extraFields];
        const index = extraFieldList.findIndex(extraFieldItem => extraFieldItem.id === extraField.id);
        if (index !== -1) {
            extraFieldList[index] = extraField;
            setExtraFields(extraFieldList);
        }
        setSelectedExtraField(undefined);
        extraFieldModalToggle();
    }

    useEffect(() => {
        getExtraFields();
    }, [extraFieldModel])

    return (<Fragment>
        <Loader visibility={loaderVisibility}/>
        <Container fluid={true}>
            <Row className={'justify-content-center'}>
                <Col md={8}>
                    {extraFields.map((extraField, key) => {
                        return <Row key={key}>
                            <Col sm={8}><TextInput name={extraField.key} type={extraField.field_type?.name || 'text'}
                                                   label={extraField.label}
                                                   register={register}
                                                   options={{required: extraField.required}}
                                                   placeholder={extraField.placeholder}/></Col>
                            <Col sm={4} style={{position: 'relative'}}>
                                {extraField?.used ? null :
                                    <div className='d-flex align-items-right gap-2 align-items-baseline'
                                         style={{position: "absolute", bottom: 17}}>
                                        <ButtonIcon size={'small'}
                                                    attrBtn={{onClick: () => handleExtraFieldEdit(extraField)}}
                                                    type={'edit'} permission={'update-extra-field'}/>
                                        <ButtonIcon size={'small'}
                                                    onclick={() => deleteExtraField(extraField.id)}
                                                    type={'delete'} permission={'delete-extra-field'}/>
                                    </div>}
                            </Col>
                        </Row>
                    })}
                </Col>
            </Row>
            <Modal isOpen={extraFieldModalVisibility} toggle={extraFieldModalToggle} centered>
                <ModalHeader>
                    {selectedExtraField ? 'Update' : 'Create'} ExtraField
                </ModalHeader>
                <ModalBody>
                    <ExtraFieldForm callBack={updateExtraField}
                                    extraField={selectedExtraField}/>
                </ModalBody>
                <ModalFooter>
                    <Btn attrBtn={{color: 'primary', onClick: extraFieldModalToggle}}>Close</Btn>
                </ModalFooter>
            </Modal>
        </Container>
    </Fragment>)
}

export default ExtraFieldShow;
